/**
 * UX-022 shared field-marker state model.
 *
 * Split out from `FieldMarkers.tsx` so the component module only exports
 * components (keeps React Fast Refresh happy). The visual marker components
 * live in `FieldMarkers.tsx` and consume this state.
 */

export type FieldMarkerState = 'owes' | 'satisfied' | 'optional' | 'none'

/**
 * Resolve which marker a field should show.
 *
 * @param required  whether the field is required in the current context
 * @param filled    whether the field currently has a valid/non-empty value
 * @param _revealed retained for API symmetry; no longer gates the "owes" rail
 *                  (the rail is default-on for required fields).
 */
export function resolveFieldMarkerState(required: boolean, filled: boolean, _revealed?: boolean): FieldMarkerState {
  if (!required) return 'optional'
  if (filled) return 'satisfied'
  // Required + empty: always show the "owes input" rail — it signals requiredness
  // from first render and does not wait for a touch/attempt (UX-022 b).
  return 'owes'
}
